import clsx from 'clsx';
import type { ReactNode } from 'react';

import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

type MailDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer: ReactNode;
  footerStart?: ReactNode;
  widthClassName?: string;
  bodyClassName?: string;
  preventClose?: boolean;
};

export default function MailDialog({
  open,
  onClose,
  title,
  children,
  footer,
  footerStart,
  widthClassName = 'w-[500px]',
  bodyClassName = 'p-lg',
  preventClose = false,
}: MailDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !preventClose) onClose();
      }}
    >
      <DialogContent
        className={clsx(
          'flex max-h-[90vh] max-w-[calc(100vw-32px)] flex-col overflow-hidden rounded-sm shadow-layer3!',
          widthClassName
        )}
      >
        <div className="shrink-0 border-b border-solid border-border px-lg py-md">
          <DialogTitle className="text-heading-xs! text-main">{title}</DialogTitle>
          <DialogDescription className="sr-only">{title}</DialogDescription>
        </div>
        <div className={clsx('min-h-0 flex-1 overflow-y-auto', bodyClassName)}>{children}</div>
        <div className="flex shrink-0 items-center justify-between gap-md border-t border-solid border-border px-lg py-md">
          <div className="min-w-0">{footerStart}</div>
          <div className="flex shrink-0 items-center gap-xs">{footer}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
